export default __webpack_public_path__ + "static/media/glo.927cbd65.jpg";